import { Element } from '../../../../../common/html/element'
import { ScrollComponent } from '../../../../../common/scrollComponent'

import classes from './index.module.scss'
import { List } from './List'

export const Vertical = ({ list, isChildren, activeItem }) => {
  return (
    <Element
      className={classes.verticalContainer}
      style={{ backgroundColor: '#EBEBEB' }}
    >
      <ScrollComponent>
        <List list={list} isChildren={isChildren} activeItem={activeItem} />
      </ScrollComponent>
    </Element>
  )
}
